// extracted by mini-css-extract-plugin
export default {"root":"O5Y69E1u","item":"TYXN9rO9","itemAvatar":"QfbdBWlU","itemButton":"kkva74Vl","itemIcon":"DAa7arWE"};